module.exports = __webpack_public_path__ + "img/menu2-2.da50ce2f.jpg";